import React from 'react';
import { useParams } from 'react-router-dom';
import { ReactFlowProvider } from '@xyflow/react';
import { useQuery } from 'react-fetching-library';

import Page from '../../components/Page';
import { AccomodationDiagramChoice } from '../../sections/employee/accomodation-diagram/AccomodationDiagramChoice';
import { AccomodationDiagramDetails } from '../../sections/employee/accomodation-diagram/AccomodationDiagramDetails';
import { AccomodationDiagramProvider } from '../../sections/employee/accomodation-diagram/AccomodationDiagramContext';
import { getAccomodationChoicesDataAction } from '../../services/request';

export default function AccomodationDiagram() {
  const { loading, payload, error } = useQuery(getAccomodationChoicesDataAction());
  const [selectedAccomodationDiagram, setSelectedAccomodationDiagram] = React.useState(null);
  const [existingAccomodations, setExistingAccomodations] = React.useState([]);
  const [allExistingAccomodations, setAllExistingAccomodations] = React.useState([]);
  const [camps, setCamps] = React.useState([]);
  const [resorts, setResorts] = React.useState([]);
  const params = useParams();

  React.useEffect(() => {
    if (!error && !loading) {
      setResorts(payload.resorts);
      setCamps(payload.camps);
      setExistingAccomodations(payload.existing_accomodations);
      setAllExistingAccomodations(payload.all_existing_accomodations);
    }
  }, [loading]);

  React.useEffect(() => {
    if (existingAccomodations.length > 0 && !selectedAccomodationDiagram) {
      setSelectedAccomodationDiagram(existingAccomodations.find(ea => ea.camp == params.camp && ea.resort == params.resort));
    }
  }, [params, existingAccomodations]);


  if (params.resort && params.camp) {
    return (selectedAccomodationDiagram &&
      <Page title="Zakwaterowanie" sx={{ width: '100%', height: '100%' }}>
        <ReactFlowProvider>
          <AccomodationDiagramProvider>
            <AccomodationDiagramDetails selectedAccomodationDiagramParams={selectedAccomodationDiagram} setSelectedAccomodationDiagram={setSelectedAccomodationDiagram} params={params} />
          </AccomodationDiagramProvider>
        </ReactFlowProvider>
      </Page>
    );
  }

  return (
    <Page title="Zakwaterowanie" sx={{ width: '100%', height: '100%' }}>
      <ReactFlowProvider>
        <AccomodationDiagramProvider>
          {!selectedAccomodationDiagram
            ? <AccomodationDiagramChoice
              setSelectedAccomodationDiagramProps={setSelectedAccomodationDiagram}
              resorts={resorts}
              camps={camps}
              existingAccomodations={existingAccomodations}
              setExistingAccomodations={setExistingAccomodations}
              allExistingAccomodations={allExistingAccomodations}
              setAllExistingAccomodations={setAllExistingAccomodations}
            />
            : <AccomodationDiagramDetails setSelectedAccomodationDiagram={setSelectedAccomodationDiagram} />}
        </AccomodationDiagramProvider>
      </ReactFlowProvider>
    </Page>
  );
};
